import { ILogMessage } from '@agoda/messaging-client';
import { getSessionId } from 'core/window/bootstrapConfig';
import { feLoggingMeasurement } from 'core/messaging/measurement/MessagingClientMeasurement';
import { MessagingClientTags } from 'component/common/Hoc/MessagingClientTags';
import { getStoreState } from 'store/store';
import { href } from 'core-framework/window/location';
import { getMandatoryMeasurementTags } from 'core/service/measurements/measurementUtils';

const componentErrorHandler = {
    handleComponentError(error: Error, componentStack: string, componentName?: string): void {
        if (!error) {
            return;
        }
        const sessionId = getSessionId();
        const state = getStoreState();
        const tags = state.bootstrap?.config ? getMandatoryMeasurementTags(state.bootstrap.config) : {};
        const log: ILogMessage = {
            level: 'error',
            message: `${MessagingClientTags.tag_ClientSide_Error}${MessagingClientTags.tag_Activity}${componentName} : Component Error`,
            exceptionMessage: error.message,
            stackTrace: componentStack ?? error.stack,
            callerModuleId: state.navigation.pageTypeId,
            applicationName: 'activities',
            url: href(),
            sessionId: sessionId || 'unknown',
            stringTags: { ...tags, category: 'client-side-error' },
            _meta: {
                type: 'log',
            },
        };
        feLoggingMeasurement.log(log);
    },
};

export { componentErrorHandler };
